import { DSNCBestProductTitle } from 'shared-definitions/types'
import { ApiComponentBestProductTitle } from 'data-source/types.wp'
import { bestProductPropsMapper } from 'data-source/mappers/bestProductPropsMapper'
import type { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncBestProductTitle(
  input: ApiComponentBestProductTitle,
  opts: PLinkMapperOpts
): DSNCBestProductTitle {
  return {
    resource: 'nc-best-product-title',
    ...bestProductPropsMapper(input, opts),
  }
}
